(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-form", [], factory);
	else if(typeof exports === 'object')
		exports["react-form"] = factory();
	else
		root["react-form"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs":
/*!*****************************************************************************!*\
  !*** ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs ***!
  \*****************************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   __addDisposableResource: () => (/* binding */ __addDisposableResource),
/* harmony export */   __assign: () => (/* binding */ __assign),
/* harmony export */   __asyncDelegator: () => (/* binding */ __asyncDelegator),
/* harmony export */   __asyncGenerator: () => (/* binding */ __asyncGenerator),
/* harmony export */   __asyncValues: () => (/* binding */ __asyncValues),
/* harmony export */   __await: () => (/* binding */ __await),
/* harmony export */   __awaiter: () => (/* binding */ __awaiter),
/* harmony export */   __classPrivateFieldGet: () => (/* binding */ __classPrivateFieldGet),
/* harmony export */   __classPrivateFieldIn: () => (/* binding */ __classPrivateFieldIn),
/* harmony export */   __classPrivateFieldSet: () => (/* binding */ __classPrivateFieldSet),
/* harmony export */   __createBinding: () => (/* binding */ __createBinding),
/* harmony export */   __decorate: () => (/* binding */ __decorate),
/* harmony export */   __disposeResources: () => (/* binding */ __disposeResources),
/* harmony export */   __esDecorate: () => (/* binding */ __esDecorate),
/* harmony export */   __exportStar: () => (/* binding */ __exportStar),
/* harmony export */   __extends: () => (/* binding */ __extends),
/* harmony export */   __generator: () => (/* binding */ __generator),
/* harmony export */   __importDefault: () => (/* binding */ __importDefault),
/* harmony export */   __importStar: () => (/* binding */ __importStar),
/* harmony export */   __makeTemplateObject: () => (/* binding */ __makeTemplateObject),
/* harmony export */   __metadata: () => (/* binding */ __metadata),
/* harmony export */   __param: () => (/* binding */ __param),
/* harmony export */   __propKey: () => (/* binding */ __propKey),
/* harmony export */   __read: () => (/* binding */ __read),
/* harmony export */   __rest: () => (/* binding */ __rest),
/* harmony export */   __rewriteRelativeImportExtension: () => (/* binding */ __rewriteRelativeImportExtension),
/* harmony export */   __runInitializers: () => (/* binding */ __runInitializers),
/* harmony export */   __setFunctionName: () => (/* binding */ __setFunctionName),
/* harmony export */   __spread: () => (/* binding */ __spread),
/* harmony export */   __spreadArray: () => (/* binding */ __spreadArray),
/* harmony export */   __spreadArrays: () => (/* binding */ __spreadArrays),
/* harmony export */   __values: () => (/* binding */ __values),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ }),

/***/ "../path-utils/dist/index.js":
/*!***********************************!*\
  !*** ../path-utils/dist/index.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getObjectPaths = exports.toPathArray = exports.normalizePath = exports.joinPathComponents = exports.joinPaths = exports.toPathString = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs");
const lodash_1 = tslib_1.__importDefault(__webpack_require__(/*! lodash */ "lodash"));
const QUOTE_REG = /"/g;
const NONWORD_REG = /\W/;
const notEmpty = (path) => path != null && path !== '';
const escapeComponent = (component) => component == null ? null : String(component).replace(QUOTE_REG, '\\"');
const stringifyPathComponent = (component, { isFirst }) => {
    if (component == null)
        return null;
    if (typeof component === 'number')
        component = String(component);
    else if (component.match(NONWORD_REG))
        return `["${escapeComponent(component)}"]`;
    return (isFirst ? '' : '.') + component;
};
/**
 * Converts an array of keys / path components into a path string.
 *
 * @see joinPaths - for joining multiple paths together
 *
 * @param  {string[]} pathArray - Path array
 * @return {string} - Path string
 */
function toPathString(pathArray) {
    return pathArray
        .map((component, index) => stringifyPathComponent(component, { isFirst: !index }))
        .join('');
}
exports.toPathString = toPathString;
/**
 * Joins two path strings together
 *
 * NOTE: each argument is considered a path, not a path component. This is important when it comes to escaping. If you want to join multiple components, use toPathString
 *
 * @example:
 *     joinPaths('foo', 'bar.baz'); // foo.bar.baz
 *     toPathString(['foo', 'bar.baz']); // foo["bar.baz"]
 *
 * @param  paths - An array of path strings to join
 * @return Full path string
 */
function joinPaths(...paths) {
    return toPathString(lodash_1.default.flatMap(paths.filter(item => notEmpty(item)), lodash_1.default.toPath));
}
exports.joinPaths = joinPaths;
/**
 * Same functionality as toPathString, but has the same API as joinPaths
 */
function joinPathComponents(...pathComponents) {
    return toPathString(pathComponents);
}
exports.joinPathComponents = joinPathComponents;
/**
 * Normalizes path strings to use bracket syntax
 *
 * @example
 * // all of the following are equivalent:
 *  foo.bar.1.2
 *  foo["bar"].1.2
 *  foo['bar'][1][2]
 *
 * // All of them will be normalized to:
 *  foo.bar[1][2]
 *
 * @param  {string} path - Path string
 * @return {string} - Full path string in bracket syntax
 *
 */
function normalizePath(path) {
    return toPathString(lodash_1.default.toPath(path));
}
exports.normalizePath = normalizePath;
/**
 * Right now it's just a wrapper on top of _.toPath, but it could change in the future
 */
function toPathArray(path) {
    return lodash_1.default.toPath(path);
}
exports.toPathArray = toPathArray;
/**
 * Gets a list of all paths in an object
 *
 * @param {Object} input - The object to get paths of
 * @param {object} options - Function options
 * @param {boolean} options.ignoreNull - whether to ignore paths if value is null
 * @return {Array} An array of all paths in the object
 */
function getObjectPaths(input = {}, options = {}) {
    const { ignoreNull = false } = options;
    const paths = [];
    const getPath = (obj, prefix = '') => {
        for (const key in obj) {
            const suffix = key.includes('.') ? `["${key}"]` : key;
            const path = `${prefix}${suffix}`;
            const value = obj[key];
            if (!ignoreNull || value !== null)
                paths.push(path);
            if (lodash_1.default.isArray(value) || lodash_1.default.isPlainObject(value)) {
                getPath(value, `${path}.`);
            }
        }
    };
    getPath(input);
    return paths.map(normalizePath);
}
exports.getObjectPaths = getObjectPaths;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./src/Field.tsx":
/*!***********************!*\
  !*** ./src/Field.tsx ***!
  \***********************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Field = void 0;
var tslib_1 = __webpack_require__(/*! tslib */ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs");
var react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
var prop_types_1 = tslib_1.__importDefault(__webpack_require__(/*! prop-types */ "prop-types"));
var lodash_1 = tslib_1.__importDefault(__webpack_require__(/*! lodash */ "lodash"));
var FormContext_1 = tslib_1.__importDefault(__webpack_require__(/*! ./FormContext */ "./src/FormContext.ts"));
;
/** @deprecated @pi/react-form is not needed anymore, just use MobX */
var Field = /** @class */ (function (_super) {
    tslib_1.__extends(Field, _super);
    function Field() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._unmount = lodash_1.default.noop;
        return _this;
    }
    Field.prototype.componentWillUnmount = function () {
        this._unmount();
    };
    Field.prototype.render = function () {
        var _a = this.props, name = _a.name, Klass = _a.component, format = _a.format, parse = _a.parse, validate = _a.validate, props = tslib_1.__rest(_a, ["name", "component", "format", "parse", "validate"]);
        if (!this.context.registerField) {
            throw new Error("<Field name='".concat(name, "' /> used outside of a <Form />"));
        }
        this._unmount = this.context.registerField(this.props.name, this, { parse: parse, format: format, validate: validate });
        return react_1.default.createElement(Klass, tslib_1.__assign({}, props, this.context.getFieldProps(this)));
    };
    Field.contextType = FormContext_1.default;
    Field.propTypes = {
        name: prop_types_1.default.string.isRequired,
        component: prop_types_1.default.func.isRequired,
        format: prop_types_1.default.func.isRequired,
        parse: prop_types_1.default.func.isRequired,
        validate: prop_types_1.default.func,
    };
    Field.defaultProps = {
        format: lodash_1.default.identity,
        parse: lodash_1.default.identity,
    };
    return Field;
}(react_1.default.PureComponent));
exports.Field = Field;
exports["default"] = Field;


/***/ }),

/***/ "./src/FieldArray.tsx":
/*!****************************!*\
  !*** ./src/FieldArray.tsx ***!
  \****************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FieldArray = void 0;
var tslib_1 = __webpack_require__(/*! tslib */ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs");
var react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
var prop_types_1 = tslib_1.__importDefault(__webpack_require__(/*! prop-types */ "prop-types"));
var FormContext_1 = tslib_1.__importDefault(__webpack_require__(/*! ./FormContext */ "./src/FormContext.ts"));
;
/** @deprecated @pi/react-form is not needed anymore, just use MobX */
var FieldArray = /** @class */ (function (_super) {
    tslib_1.__extends(FieldArray, _super);
    function FieldArray() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FieldArray.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this._unmount) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    FieldArray.prototype.render = function () {
        var _a = this.props, name = _a.name, Klass = _a.component, props = tslib_1.__rest(_a, ["name", "component"]);
        if (!this.context.registerField) {
            throw new Error("<FieldArray name='".concat(name, "' /> used outside of a <Form />"));
        }
        this._unmount = this.context.registerField(this.props.name, this);
        return react_1.default.createElement(Klass, tslib_1.__assign({}, props, this.context.getArrayFieldProps(this)));
    };
    FieldArray.contextType = FormContext_1.default;
    FieldArray.propTypes = {
        name: prop_types_1.default.string.isRequired,
        component: prop_types_1.default.func.isRequired,
    };
    return FieldArray;
}(react_1.default.PureComponent));
exports.FieldArray = FieldArray;
exports["default"] = FieldArray;


/***/ }),

/***/ "./src/Fields.tsx":
/*!************************!*\
  !*** ./src/Fields.tsx ***!
  \************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Fields = void 0;
var tslib_1 = __webpack_require__(/*! tslib */ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs");
var react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
var prop_types_1 = tslib_1.__importDefault(__webpack_require__(/*! prop-types */ "prop-types"));
var FormContext_1 = tslib_1.__importDefault(__webpack_require__(/*! ./FormContext */ "./src/FormContext.ts"));
;
/** @deprecated @pi/react-form is not needed anymore, just use MobX */
var Fields = /** @class */ (function (_super) {
    tslib_1.__extends(Fields, _super);
    function Fields() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Fields.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this._unmount) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    Fields.prototype.render = function () {
        var _a = this.props, names = _a.names, Klass = _a.component, props = tslib_1.__rest(_a, ["names", "component"]);
        if (!this.context.registerField) {
            throw new Error("<Fields names={".concat(JSON.stringify(names), "} /> used outside of a <Form />"));
        }
        this._unmount = this.context.registerField(this.props.names, this);
        return react_1.default.createElement(Klass, tslib_1.__assign({}, props, this.context.getFieldsProps(this), { names: names }));
    };
    Fields.contextType = FormContext_1.default;
    Fields.propTypes = {
        names: prop_types_1.default.oneOfType([
            prop_types_1.default.arrayOf(prop_types_1.default.string.isRequired).isRequired,
            prop_types_1.default.objectOf(prop_types_1.default.string).isRequired,
        ]).isRequired,
        component: prop_types_1.default.func.isRequired,
    };
    return Fields;
}(react_1.default.PureComponent));
exports.Fields = Fields;
exports["default"] = Fields;


/***/ }),

/***/ "./src/Form.tsx":
/*!**********************!*\
  !*** ./src/Form.tsx ***!
  \**********************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Form = void 0;
var tslib_1 = __webpack_require__(/*! tslib */ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs");
var react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
var prop_types_1 = tslib_1.__importDefault(__webpack_require__(/*! prop-types */ "prop-types"));
var lodash_1 = tslib_1.__importDefault(__webpack_require__(/*! lodash */ "lodash"));
var path_utils_1 = __webpack_require__(/*! @pi/path-utils */ "../path-utils/dist/index.js");
var getImmer_1 = tslib_1.__importDefault(__webpack_require__(/*! ./utils/getImmer */ "./src/utils/getImmer.ts"));
var validation_1 = __webpack_require__(/*! ./utils/validation */ "./src/utils/validation.ts");
var FormContext_1 = tslib_1.__importDefault(__webpack_require__(/*! ./FormContext */ "./src/FormContext.ts"));
;
var defaultRegisteredFieldProps = {
    update: lodash_1.default.noop,
    parse: lodash_1.default.identity,
    format: lodash_1.default.identity,
    validate: lodash_1.default.noop,
};
/** @deprecated @pi/react-form is not needed anymore, just use MobX */
var Form = /** @class */ (function (_super) {
    tslib_1.__extends(Form, _super);
    function Form(props) {
        var e_1, _a;
        var _this = _super.call(this, props) || this;
        _this.state = {
            version: 0,
            immer: (0, getImmer_1.default)(),
            getFormState: function () { return _this.formState; },
            getFormProps: function () { return _this.getFormProps(); },
            getValue: function () { return _this.formState.value; },
        };
        _this.formState = {
            valid: true,
            value: _this.props.initialValues || {},
            fields: {},
            instanceMap: new WeakMap,
            events: {},
            meta: {},
        };
        var toBind = [
            'changeField',
            'getArrayFieldProps',
            'getErrors',
            'getFieldProps',
            'getFieldsProps',
            'registerEvent',
            'registerEventOnce',
            'registerField',
            'touchFields',
        ];
        var _loop_1 = function (key) {
            // @ts-ignore
            this_1.state[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return _this[key].apply(_this, tslib_1.__spreadArray([], tslib_1.__read(args), false));
            };
        };
        var this_1 = this;
        try {
            for (var toBind_1 = tslib_1.__values(toBind), toBind_1_1 = toBind_1.next(); !toBind_1_1.done; toBind_1_1 = toBind_1.next()) {
                var key = toBind_1_1.value;
                _loop_1(key);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (toBind_1_1 && !toBind_1_1.done && (_a = toBind_1.return)) _a.call(toBind_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        _this.applyValidation(_this.formState.value, _this.props.validate);
        return _this;
    }
    Form.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.initialValues !== this.props.initialValues) {
            this.formState.value = this.props.initialValues || {};
            this.updateFieldsForPaths(lodash_1.default.map(this.formState.fields, function (v, key) { return lodash_1.default.toPath(key); }));
            this.setState({ version: this.state.version + 1 });
        }
        if (prevProps.validate !== this.props.validate) {
            this.applyValidation(this.formState.value, this.props.validate);
            if (!lodash_1.default.isEmpty(this.formState.meta)) {
                this.updateFieldsForPaths(lodash_1.default.map(this.formState.meta, function (v, path) { return lodash_1.default.toPath(path); }));
            }
        }
    };
    Form.prototype.registerEvent = function (instance, event, callback) {
        var events = this.formState.events;
        var unregister = function () {
            for (var key in events) {
                events[key] = events[key].filter(function (h) { return h.instance !== instance; });
            }
        };
        // Firstly remove the instance from all other events
        unregister();
        events[event] = events[event] || [];
        events[event].push({ instance: instance, callback: callback });
        if (event === 'init')
            callback(tslib_1.__assign({}, this.getFormProps()));
        return unregister;
    };
    Form.prototype.registerEventOnce = function (instance, event, callback) {
        var unregister = this.registerEvent(instance, event, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            callback.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args), false));
            unregister();
        });
        return unregister;
    };
    Form.prototype.registerField = function (originalNames, instance, props) {
        var e_2, _a;
        var _this = this;
        var names;
        if (typeof originalNames === 'string')
            names = [originalNames];
        else if (Array.isArray(originalNames))
            names = originalNames;
        else
            names = Object.values(originalNames);
        names = names.filter(function (n) { return n != null; }).map(path_utils_1.normalizePath);
        var unmount = function () {
            var e_3, _a;
            var fields = _this.formState.fields;
            try {
                for (var names_2 = tslib_1.__values(names), names_2_1 = names_2.next(); !names_2_1.done; names_2_1 = names_2.next()) {
                    var name_1 = names_2_1.value;
                    if (!fields[name_1])
                        continue;
                    fields[name_1] = fields[name_1].filter(function (item) { return item !== instance; });
                    if (!fields[name_1].length) {
                        delete _this.formState.meta[name_1];
                        _this.formState.instanceMap.delete(instance);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (names_2_1 && !names_2_1.done && (_a = names_2.return)) _a.call(names_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
        };
        // Remove the instance from all other events if its names change
        var existing = this.formState.instanceMap.get(instance);
        if (existing) {
            if (!lodash_1.default.isEqual(originalNames, existing.originalNames))
                unmount();
        }
        var fields = this.formState.fields;
        try {
            for (var names_1 = tslib_1.__values(names), names_1_1 = names_1.next(); !names_1_1.done; names_1_1 = names_1.next()) {
                var name_2 = names_1_1.value;
                fields[name_2] = fields[name_2] || [];
                if (!fields[name_2].find(function (item) { return item === instance; })) {
                    fields[name_2].push(instance);
                    if (!existing)
                        this.updateMeta(name_2, { touched: false });
                    var propsWithDefaults = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ name: name_2, names: names, originalNames: originalNames }, defaultRegisteredFieldProps), { update: function () { return instance.forceUpdate(); } }), props);
                    this.formState.instanceMap.set(instance, propsWithDefaults);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (names_1_1 && !names_1_1.done && (_a = names_1.return)) _a.call(names_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return unmount;
    };
    Form.prototype.eachEvent = function (name, callback) {
        var e_4, _a;
        try {
            for (var _b = tslib_1.__values(this.formState.events[name] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
                var event_1 = _c.value;
                callback(event_1.callback, event_1);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    Form.prototype.applyValidation = function (formValue, validator) {
        var _this = this;
        this.formState.valid = true;
        lodash_1.default.forEach(this.formState.meta, function (meta) { delete meta.error; });
        if (!validator)
            return;
        var errors = (0, validation_1.applyValidation)(formValue, validator).errors;
        this.formState.valid = lodash_1.default.isEmpty(errors);
        lodash_1.default.forEach(errors, function (err, path) { return _this.setError(path, err); });
    };
    Form.prototype.getErrors = function (formMeta) {
        if (formMeta === void 0) { formMeta = this.formState.meta; }
        var errors = {};
        lodash_1.default.forEach(formMeta, function (meta, path) {
            if (meta.error)
                errors[path] = meta.error;
        });
        return errors;
    };
    Form.prototype.getFormProps = function () {
        var _this = this;
        return {
            valid: this.formState.valid,
            formValue: this.formState.value,
            getFormValue: function () { return _this.formState.value; },
            context: this.state,
        };
    };
    Form.prototype.getFirstFieldPropsForName = function (name) {
        var result;
        var bucket = this.formState.fields[name];
        if (bucket === null || bucket === void 0 ? void 0 : bucket.length)
            result = this.formState.instanceMap.get(bucket[0]);
        return result || tslib_1.__assign({ name: name, names: [name], originalNames: name }, defaultRegisteredFieldProps);
    };
    Form.prototype.changeField = function (name, value) {
        if (value && value.nativeEvent && value.nativeEvent instanceof Event) {
            value = value.target.value;
        }
        return this.changeFieldProduce({
            name: name,
            mutate: function () { return value; },
            allowUndefined: true,
        });
    };
    Form.prototype.changeFieldProduce = function (_a) {
        var e_5, _b;
        var _this = this;
        var name = _a.name, mutate = _a.mutate, _c = _a.allowUndefined, allowUndefined = _c === void 0 ? false : _c;
        var immer = this.state.immer;
        var _d = this.props, validate = _d.validate, debug = _d.debug;
        var groupName = "change: ".concat(name);
        var format = this.getFirstFieldPropsForName(name).format;
        if (debug) {
            console.group(groupName);
            console.info('name =', name);
        }
        var newValue;
        var handleUpdate = function (formValueDraft) {
            var currentDraft = formValueDraft;
            // You can change the root value by returning a new value entirely
            // This is rarely needed, usually it's actually a bug, but if you do need it, this is the method to do that
            var setReturnValue = function (newReturnValue) {
                currentDraft = newReturnValue;
                return currentDraft;
            };
            var options = tslib_1.__assign(tslib_1.__assign({ name: name, get formValueDraft() { return currentDraft; }, setReturnValue: setReturnValue, get formValue() { return immer.current(currentDraft); } }, lodash_1.default.omit(_this.getFormProps(), ['formValue', 'getFormValue'])), { getFormValue: function () { return immer.current(currentDraft); } });
            _this.eachEvent('pre:change', function (callback) { return callback(options); });
            _this.updateMeta(name, { touched: true });
            var oldValue = lodash_1.default.get(currentDraft, name);
            newValue = mutate(oldValue);
            if (!allowUndefined) {
                if (newValue === undefined)
                    newValue = oldValue;
                else if (newValue === immer.nothing)
                    newValue = undefined;
            }
            newValue = format(newValue);
            if (debug) {
                console.info('new value =', immer.isDraft(newValue) ? immer.current(newValue) : newValue);
                // console.info('new value is draft =', immer.isDraft(newValue));
                console.info('old value =', immer.isDraft(oldValue) ? immer.current(oldValue) : oldValue);
                console.info('old value === new value', oldValue === newValue);
            }
            lodash_1.default.set(currentDraft, name, newValue);
            _this.eachEvent('post:change', function (callback) { return callback(options); });
            return currentDraft;
        };
        var _e = tslib_1.__read(immer.produceWithPatches(this.formState.value, handleUpdate), 2), newFormValue = _e[0], patches = _e[1];
        this.formState.value = newFormValue;
        var metaPaths = this.updateMetaForFields([lodash_1.default.toPath(name)], newFormValue);
        if (validate) {
            var existingPatches = lodash_1.default.keyBy(patches.map(function (p) { return (0, path_utils_1.toPathString)(p.path); }));
            try {
                for (var metaPaths_1 = tslib_1.__values(metaPaths), metaPaths_1_1 = metaPaths_1.next(); !metaPaths_1_1.done; metaPaths_1_1 = metaPaths_1.next()) {
                    var path = metaPaths_1_1.value;
                    if (!existingPatches[(0, path_utils_1.toPathString)(path)]) {
                        patches.push({
                            op: 'add',
                            path: path,
                        });
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (metaPaths_1_1 && !metaPaths_1_1.done && (_b = metaPaths_1.return)) _b.call(metaPaths_1);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
        var paths = this.updateFieldsForPaths(getPathsFromPatches(patches));
        if (debug) {
            console.info('patches(%d) =', patches.length);
            console.info(patches.map(function (x) { return "\t\u2192 ".concat(x.op, " | ").concat((0, path_utils_1.toPathString)(x.path)); }).join('\n'));
            console.info('patches =', patches);
            console.groupCollapsed("paths(".concat(paths.length, ")"));
            console.info(paths.join('\n'));
            console.groupEnd();
            console.groupEnd();
        }
        this.eachEvent('post:update', function (callback) {
            return callback(tslib_1.__assign({ name: name, value: newValue, patches: patches, paths: paths }, _this.getFormProps()));
        });
    };
    Form.prototype.updateFieldsForPaths = function (paths) {
        var e_6, _a;
        var _b;
        var finalPaths = [];
        if (!paths.length)
            return [];
        if (!Array.isArray(paths[0]))
            throw new Error('only supports array paths');
        // makes parents update before children, potentially prunes child updates
        paths = Array.from(paths).sort();
        var processed = {};
        try {
            for (var paths_1 = tslib_1.__values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) { // trigger updates for all changed paths
                var path = paths_1_1.value;
                for (var i = 1; i <= path.length; ++i) { // trigger updates for every ancestor
                    var nextPath = (0, path_utils_1.toPathString)(path.slice(0, i));
                    if (processed[nextPath])
                        continue;
                    processed[nextPath] = true;
                    finalPaths.push(nextPath);
                    var bucket = this.formState.fields[nextPath] || [];
                    for (var j = 0; j < bucket.length; ++j) {
                        (_b = this.formState.instanceMap.get(bucket[j])) === null || _b === void 0 ? void 0 : _b.update();
                    }
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
            }
            finally { if (e_6) throw e_6.error; }
        }
        return finalPaths;
    };
    Form.prototype.updateMeta = function (path, diff) {
        var meta = this.formState.meta;
        if (!meta[path])
            meta[path] = { valid: true, touched: false };
        Object.assign(meta[path], diff);
    };
    Form.prototype.setError = function (path, error) {
        var diff = {
            valid: !error,
            error: error,
        };
        if (!diff.valid && this.props.touchOnError)
            diff.touched = true;
        this.updateMeta(path, diff);
    };
    /**
     * Update the compute .meta props for a given list of paths
     * Also runs the global form validation
     *
     * @param paths
     * @param [formValue=this.formState.value]
     */
    Form.prototype.updateMetaForFields = function (paths, formValue) {
        var e_7, _a;
        if (formValue === void 0) { formValue = this.formState.value; }
        var validate = this.props.validate;
        // run the global form validation
        this.applyValidation(formValue, validate);
        try {
            // run each individual field's validation and update the formState.meta
            for (var paths_2 = tslib_1.__values(paths), paths_2_1 = paths_2.next(); !paths_2_1.done; paths_2_1 = paths_2.next()) {
                var path = paths_2_1.value;
                var pathStr = (0, path_utils_1.toPathString)(path);
                var fieldValidate = this.getFirstFieldPropsForName(pathStr).validate;
                if (!fieldValidate)
                    continue;
                var value = lodash_1.default.get(this.formState.value, path);
                var _b = (0, validation_1.getSingleValueValidationHandlers)(value), check = _b.check, getError = _b.getError;
                fieldValidate({ value: value, check: check });
                var error = getError();
                this.setError(pathStr, error);
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (paths_2_1 && !paths_2_1.done && (_a = paths_2.return)) _a.call(paths_2);
            }
            finally { if (e_7) throw e_7.error; }
        }
        // return paths for all fields that have changed
        return lodash_1.default.map(this.getErrors(), function (err, path) { return lodash_1.default.toPath(path); });
    };
    Form.prototype.baseGetFieldProps = function (_a) {
        var _this = this;
        var name = _a.name, format = _a.format, parse = _a.parse;
        var value = lodash_1.default.get(this.formState.value, name);
        //if (value == null) value = '';
        if (format)
            value = format(value);
        return {
            input: {
                name: name,
                value: value,
                onChange: function (value) {
                    return _this.changeField(name, parse ? parse(value) : value);
                },
                produce: function (mutate) {
                    return _this.changeFieldProduce({ name: name, mutate: mutate });
                },
            },
            meta: tslib_1.__assign({}, this.formState.meta[name]),
        };
    };
    Form.prototype.getFieldProps = function (instance) {
        return this.baseGetFieldProps(this.formState.instanceMap.get(instance));
    };
    Form.prototype.getFieldsProps = function (instance) {
        var e_8, _a;
        var _this = this;
        var originalNames = this.formState.instanceMap.get(instance).originalNames;
        if (Array.isArray(originalNames)) {
            var fields = {};
            // By sorting and reversing we ensure that child inputs override parents
            // e.g.
            //  names = [foo.bar, foo, foo.alpha, baz]
            //  fields = {
            //      foo: {
            //          alpha: { input },
            //          bar: { input },
            //      },
            //      baz: { input }
            //  }
            originalNames = Array.from(originalNames);
            originalNames.sort().reverse();
            try {
                for (var originalNames_1 = tslib_1.__values(originalNames), originalNames_1_1 = originalNames_1.next(); !originalNames_1_1.done; originalNames_1_1 = originalNames_1.next()) {
                    var name_3 = originalNames_1_1.value;
                    lodash_1.default.set(fields, name_3, this.baseGetFieldProps(tslib_1.__assign(tslib_1.__assign({}, defaultRegisteredFieldProps), { name: name_3 })));
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (originalNames_1_1 && !originalNames_1_1.done && (_a = originalNames_1.return)) _a.call(originalNames_1);
                }
                finally { if (e_8) throw e_8.error; }
            }
            return fields;
        }
        if (lodash_1.default.isPlainObject(originalNames)) {
            return lodash_1.default.mapValues(originalNames, function (name) { return _this.baseGetFieldProps({ name: name }); });
        }
        console.warn('[Fields] Invalid names, must be an array or an object');
        return {};
    };
    Form.prototype.getArrayFieldProps = function (instance) {
        var _a;
        var _b = this.getFieldProps(instance), input = _b.input, meta = _b.meta;
        var length = ((_a = input.value) === null || _a === void 0 ? void 0 : _a.length) || 0;
        var proxy = function (callback) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                input.produce(function (draft) {
                    return callback(Array.isArray(draft) ? draft : [], args);
                });
                return null;
            };
        };
        var mutateProxy = function (method) {
            return proxy(function (draft, args) {
                draft[method].apply(draft, tslib_1.__spreadArray([], tslib_1.__read(args), false));
                return draft;
            });
        };
        var swap = proxy(function (draft, _a) {
            var _b = tslib_1.__read(_a, 2), fromIndex = _b[0], toIndex = _b[1];
            var _c = tslib_1.__read(draft.splice(fromIndex, 1), 1), removed = _c[0];
            draft.splice(toIndex, 0, removed);
            return draft;
        });
        var fields = {
            name: input.name,
            length: length,
            push: mutateProxy('push'),
            pop: mutateProxy('pop'),
            shift: mutateProxy('shift'),
            unshift: mutateProxy('unshift'),
            splice: mutateProxy('splice'),
            swap: swap,
            map: function (callback) {
                return lodash_1.default.range(length).map(function (index) { return callback((0, path_utils_1.joinPaths)(input.name, index), index); });
            },
            remove: function (index) { return fields.splice(index, 1); },
        };
        return { fields: fields, meta: meta };
    };
    Form.prototype.touchFields = function (paths) {
        var _this = this;
        var pathArrays = paths.map(function (path) {
            _this.updateMeta(path, { touched: true });
            return lodash_1.default.toPath(path);
        });
        this.updateFieldsForPaths(this.updateMetaForFields(pathArrays));
    };
    Form.prototype.render = function () {
        return react_1.default.createElement(FormContext_1.default.Provider, tslib_1.__assign({ key: this.state.version }, this.props, { value: this.state }));
    };
    Form.propTypes = {
        initialValues: prop_types_1.default.object,
        debug: prop_types_1.default.bool,
        validate: prop_types_1.default.func,
        touchOnError: prop_types_1.default.bool,
    };
    Form.defaultProps = {
        initialValues: {},
        touchOnError: false,
    };
    return Form;
}(react_1.default.PureComponent));
exports.Form = Form;
var getPathsFromPatches = function (patches) {
    var paths = [];
    var iterator = function (path, value) {
        paths.push(path);
        if (lodash_1.default.isPlainObject(value)) {
            for (var key in value)
                iterator(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(path), false), [key], false), value[key]);
        }
        else if (Array.isArray(value)) {
            value.forEach(function (child, index) { return iterator(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(path), false), [index], false), child); });
        }
    };
    patches.forEach(function (patch) { return iterator(patch.path, patch.value); });
    return paths;
};
exports["default"] = Form;


/***/ }),

/***/ "./src/FormContext.ts":
/*!****************************!*\
  !*** ./src/FormContext.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FormContext = void 0;
var tslib_1 = __webpack_require__(/*! tslib */ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs");
var react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
exports.FormContext = react_1.default.createContext({});
exports["default"] = exports.FormContext;


/***/ }),

/***/ "./src/FormEvent.tsx":
/*!***************************!*\
  !*** ./src/FormEvent.tsx ***!
  \***************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FormEvent = void 0;
var tslib_1 = __webpack_require__(/*! tslib */ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs");
var react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
var prop_types_1 = tslib_1.__importDefault(__webpack_require__(/*! prop-types */ "prop-types"));
var FormContext_1 = tslib_1.__importDefault(__webpack_require__(/*! ./FormContext */ "./src/FormContext.ts"));
;
/** @deprecated @pi/react-form is not needed anymore, just use MobX */
var FormEvent = /** @class */ (function (_super) {
    tslib_1.__extends(FormEvent, _super);
    function FormEvent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            result: null,
        };
        _this._isUnmounted = false;
        return _this;
    }
    FormEvent.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, render = _a.render, on = _a.on, callback = _a.callback;
        if (!this.context.registerField) {
            throw new Error("<FormEvent on='".concat(on, "' /> used outside of a <Form />"));
        }
        if (render && callback) {
            console.warn("<FormEvent on='".concat(on, "' /> callback and render are not supported at once. Using only callback()"));
        }
        if (callback) {
            this._unregister = this.context.registerEvent(this, on, callback);
        }
        else if (render) {
            this.setStateSafe({
                result: render(this.context.getFormProps()),
            });
            this._unregister = this.context.registerEvent(this, on, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                _this.setStateSafe({ result: render.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args), false)) });
            });
        }
    };
    FormEvent.prototype.componentWillUnmount = function () {
        this._isUnmounted = true;
        if (this._unregister)
            this._unregister();
    };
    FormEvent.prototype.setStateSafe = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this._isUnmounted)
            return;
        return this.setState.apply(this, tslib_1.__spreadArray([], tslib_1.__read(args), false));
    };
    FormEvent.prototype.render = function () {
        return this.state.result;
    };
    FormEvent.contextType = FormContext_1.default;
    FormEvent.propTypes = {
        on: prop_types_1.default.string.isRequired,
        callback: prop_types_1.default.func,
        render: prop_types_1.default.func,
    };
    return FormEvent;
}(react_1.default.PureComponent));
exports.FormEvent = FormEvent;
exports["default"] = FormEvent;


/***/ }),

/***/ "./src/index.tsx":
/*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getImmer = exports.setImmer = exports.joinPaths = exports.toPathString = exports.FormEvent = exports.FormContext = exports.Form = exports.Fields = exports.FieldArray = exports.Field = void 0;
var tslib_1 = __webpack_require__(/*! tslib */ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs");
var Field_1 = __webpack_require__(/*! ./Field */ "./src/Field.tsx");
Object.defineProperty(exports, "Field", ({ enumerable: true, get: function () { return Field_1.Field; } }));
var FieldArray_1 = __webpack_require__(/*! ./FieldArray */ "./src/FieldArray.tsx");
Object.defineProperty(exports, "FieldArray", ({ enumerable: true, get: function () { return FieldArray_1.FieldArray; } }));
var Fields_1 = __webpack_require__(/*! ./Fields */ "./src/Fields.tsx");
Object.defineProperty(exports, "Fields", ({ enumerable: true, get: function () { return Fields_1.Fields; } }));
var Form_1 = __webpack_require__(/*! ./Form */ "./src/Form.tsx");
Object.defineProperty(exports, "Form", ({ enumerable: true, get: function () { return Form_1.Form; } }));
var FormContext_1 = __webpack_require__(/*! ./FormContext */ "./src/FormContext.ts");
Object.defineProperty(exports, "FormContext", ({ enumerable: true, get: function () { return FormContext_1.FormContext; } }));
var FormEvent_1 = __webpack_require__(/*! ./FormEvent */ "./src/FormEvent.tsx");
Object.defineProperty(exports, "FormEvent", ({ enumerable: true, get: function () { return FormEvent_1.FormEvent; } }));
tslib_1.__exportStar(__webpack_require__(/*! ./FormEvent */ "./src/FormEvent.tsx"), exports);
var path_utils_1 = __webpack_require__(/*! @pi/path-utils */ "../path-utils/dist/index.js");
Object.defineProperty(exports, "toPathString", ({ enumerable: true, get: function () { return path_utils_1.toPathString; } }));
Object.defineProperty(exports, "joinPaths", ({ enumerable: true, get: function () { return path_utils_1.joinPaths; } }));
var getImmer_1 = __webpack_require__(/*! ./utils/getImmer */ "./src/utils/getImmer.ts");
Object.defineProperty(exports, "setImmer", ({ enumerable: true, get: function () { return getImmer_1.setImmer; } }));
Object.defineProperty(exports, "getImmer", ({ enumerable: true, get: function () { return getImmer_1.getImmer; } }));
tslib_1.__exportStar(__webpack_require__(/*! ./typeDefs */ "./src/typeDefs.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./propTypes/FormFieldInputType */ "./src/propTypes/FormFieldInputType.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./propTypes/FormFieldMetaType */ "./src/propTypes/FormFieldMetaType.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./propTypes/FormFieldType */ "./src/propTypes/FormFieldType.ts"), exports);


/***/ }),

/***/ "./src/propTypes/FormFieldInputType.ts":
/*!*********************************************!*\
  !*** ./src/propTypes/FormFieldInputType.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FormFieldInputType = void 0;
var tslib_1 = __webpack_require__(/*! tslib */ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs");
var prop_types_1 = tslib_1.__importDefault(__webpack_require__(/*! prop-types */ "prop-types"));
exports.FormFieldInputType = prop_types_1.default.shape({
    value: prop_types_1.default.any,
    name: prop_types_1.default.string.isRequired,
    onChange: prop_types_1.default.func.isRequired,
    produce: prop_types_1.default.func.isRequired,
});


/***/ }),

/***/ "./src/propTypes/FormFieldMetaType.ts":
/*!********************************************!*\
  !*** ./src/propTypes/FormFieldMetaType.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FormFieldMetaType = void 0;
var tslib_1 = __webpack_require__(/*! tslib */ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs");
var prop_types_1 = tslib_1.__importDefault(__webpack_require__(/*! prop-types */ "prop-types"));
exports.FormFieldMetaType = prop_types_1.default.shape({
    error: prop_types_1.default.string,
    valid: prop_types_1.default.bool,
    touched: prop_types_1.default.bool,
});


/***/ }),

/***/ "./src/propTypes/FormFieldType.ts":
/*!****************************************!*\
  !*** ./src/propTypes/FormFieldType.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FormFieldType = void 0;
var tslib_1 = __webpack_require__(/*! tslib */ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs");
var prop_types_1 = tslib_1.__importDefault(__webpack_require__(/*! prop-types */ "prop-types"));
var FormFieldInputType_1 = __webpack_require__(/*! ./FormFieldInputType */ "./src/propTypes/FormFieldInputType.ts");
var FormFieldMetaType_1 = __webpack_require__(/*! ./FormFieldMetaType */ "./src/propTypes/FormFieldMetaType.ts");
exports.FormFieldType = prop_types_1.default.shape({
    input: FormFieldInputType_1.FormFieldInputType,
    meta: FormFieldMetaType_1.FormFieldMetaType,
});


/***/ }),

/***/ "./src/typeDefs.ts":
/*!*************************!*\
  !*** ./src/typeDefs.ts ***!
  \*************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
;


/***/ }),

/***/ "./src/utils/getImmer.ts":
/*!*******************************!*\
  !*** ./src/utils/getImmer.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getImmer = exports.setImmer = void 0;
var tslib_1 = __webpack_require__(/*! tslib */ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs");
var defaultImmerModule = tslib_1.__importStar(__webpack_require__(/*! immer */ "immer"));
var immerModule;
function setImmer(newImmer) {
    immerModule = newImmer;
    newImmer.enablePatches();
    // This causes issues when assigning objects to themselves
    //  const state = {
    //      foo: { bar: 123 },
    //  }
    //
    //  <Field name='foo' component={input => input.onChange(input.value)} />
    //
    // In that example, state.foo will be frozen and all FormEvents will receive it as a frozen object
    //  instead of a draft
    newImmer.setAutoFreeze(false);
}
exports.setImmer = setImmer;
function getImmer() { return immerModule; }
exports.getImmer = getImmer;
setImmer(defaultImmerModule);
exports["default"] = getImmer;


/***/ }),

/***/ "./src/utils/validation.ts":
/*!*********************************!*\
  !*** ./src/utils/validation.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CurryValidator = exports.Validator = exports.getSingleValueValidationHandlers = exports.applyValidation = void 0;
var tslib_1 = __webpack_require__(/*! tslib */ "../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs");
var lodash_1 = tslib_1.__importDefault(__webpack_require__(/*! lodash */ "lodash"));
var path_utils_1 = __webpack_require__(/*! @pi/path-utils */ "../path-utils/dist/index.js");
/**
 * 2 ways of using validation:
 * - the boring way:
 *  check.required('text') &&
 *      check.match('text', /foo/) &&
 *      check.whatever(...)
 *
 * - the curried way:
 *  check('text')
 *      .required()
 *      .match(/foo/)
 *      .whatever(...)
 */
function applyValidation(formValue, validator) {
    var v = new Validator({ value: formValue });
    validator({ values: formValue, check: v.getCheck() });
    return { errors: v.errors };
}
exports.applyValidation = applyValidation;
function getSingleValueValidationHandlers(value) {
    var v = new Validator({ value: { field: value } });
    return {
        check: v.curry('field'),
        getError: function () { return v.errors.field; },
    };
}
exports.getSingleValueValidationHandlers = getSingleValueValidationHandlers;
var Validator = /** @class */ (function () {
    function Validator(_a) {
        var value = _a.value, _b = _a.path, path = _b === void 0 ? null : _b, _c = _a.errors, errors = _c === void 0 ? {} : _c;
        var _this = this;
        /**
         * Validation handlers convention:
         *  - first argument validate always the context that contains { value, path, handlers, ... }
         *  - if invalid it returns an error message
         *  - a default error message should be the last argument
         */
        this.baseHandlers = {
            error: function (ctx, message) {
                if (message === void 0) { message = 'invalid'; }
                return message;
            },
            assert: function (_a, message) {
                var value = _a.value;
                if (message === void 0) { message = 'invalid'; }
                if (!value)
                    return message;
            },
            required: function (_a, message) {
                var value = _a.value, path = _a.path;
                if (message === void 0) { message = 'required'; }
                if (value == null || value === '')
                    return message;
            },
            match: function (_a, reg, message) {
                var value = _a.value, path = _a.path;
                if (message === void 0) { message = 'invalid format'; }
                if (!_this.handlers.required(path))
                    return message;
                if (!reg.test(value))
                    return message;
            },
            valid: function (_a, validator, message) {
                var value = _a.value;
                if (message === void 0) { message = 'invalid'; }
                var result = validator(value);
                if (result == null || result === true)
                    return;
                return result === false ? message : result;
            },
            size: function (_a, min, max, message) {
                var value = _a.value;
                if (min === void 0) { min = null; }
                if (max === void 0) { max = null; }
                if (message === void 0) { message = null; }
                var size = lodash_1.default.size(value);
                if (min != null && size < min)
                    return message || "Too few items. At least ".concat(min, " required");
                if (max != null && size > max)
                    return message || "Too many items. At most ".concat(max, " required");
            },
        };
        // These handlers don't return an error and usually apply some other kind of validation
        // e.g. field() returns a curried validation
        this.chainHandlers = {
            each: function (_a, childValidator) {
                var value = _a.value, path = _a.path;
                if (!Array.isArray(value) && !lodash_1.default.isPlainObject(value))
                    return;
                lodash_1.default.forEach(value, function (v, k) {
                    childValidator(_this.curry((0, path_utils_1.joinPaths)(path, k)), v, k);
                });
            },
            field: function (_a, fieldPath) {
                var value = _a.value, path = _a.path;
                return _this.curry((0, path_utils_1.joinPaths)(path, fieldPath));
            },
        };
        this.value = value;
        this.path = path;
        this.errors = errors;
        this.handlers = this.getHandlers();
    }
    Validator.prototype.extend = function (props) {
        return new Validator(tslib_1.__assign(tslib_1.__assign({}, lodash_1.default.pick(this, ['value', 'path', 'errors'])), props));
    };
    Validator.prototype.curry = function (path) {
        return new CurryValidator({
            value: lodash_1.default.get(this.value, path),
            path: (0, path_utils_1.joinPaths)(this.path, path),
            errors: this.errors,
        });
    };
    Validator.prototype.getCheck = function () {
        var _this = this;
        var check = function (path) { return _this.curry(path); };
        Object.assign(check, this.handlers);
        return check;
    };
    Validator.prototype.getHandlers = function () {
        var _this = this;
        var wrapValidator = function (type, callback) {
            return function (validator, validatorName) {
                var fn = function (path) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    var absolutePath = (0, path_utils_1.joinPaths)(_this.path, path);
                    var value = path ? lodash_1.default.get(_this.value, path) : _this.value;
                    // console.log('[%s] %s =', validatorName, absolutePath, value, ...args);
                    var context = {
                        value: value,
                        path: path,
                        absolutePath: absolutePath,
                    };
                    return callback({
                        validator: validator,
                        validatorName: validatorName,
                        context: context,
                        result: validator.apply(void 0, tslib_1.__spreadArray([context], tslib_1.__read(args), false)),
                    });
                };
                fn.type = type;
                return fn;
            };
        };
        return tslib_1.__assign(tslib_1.__assign({}, lodash_1.default.mapValues(this.baseHandlers, wrapValidator('baseHandlers', function (_a) {
            var err = _a.result, absolutePath = _a.context.absolutePath;
            if (err)
                _this.errors[absolutePath] = err;
            return !err;
        }))), lodash_1.default.mapValues(this.chainHandlers, wrapValidator('chainHandlers', function (_a) {
            var result = _a.result;
            return result;
        })));
    };
    return Validator;
}());
exports.Validator = Validator;
var CurryValidator = /** @class */ (function (_super) {
    tslib_1.__extends(CurryValidator, _super);
    function CurryValidator(_a) {
        var e_1, _b;
        var _this = this;
        var _c = _a.isValid, isValid = _c === void 0 ? true : _c, props = tslib_1.__rest(_a, ["isValid"]);
        _this = _super.call(this, props) || this;
        _this.isValid = isValid;
        var curryHandler = function (fn) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (fn.type === 'baseHandlers') {
                    _this.isValid = _this.isValid && fn.apply(void 0, tslib_1.__spreadArray([null], tslib_1.__read(args), false));
                    return _this.extend();
                }
                return fn.apply(void 0, tslib_1.__spreadArray([null], tslib_1.__read(args), false));
            };
        };
        try {
            for (var _d = tslib_1.__values(Object.entries(_this.handlers)), _e = _d.next(); !_e.done; _e = _d.next()) {
                var _f = tslib_1.__read(_e.value, 2), handlerName = _f[0], fn = _f[1];
                if (Reflect.has(_this, handlerName)) {
                    throw new Error("Handler \"".concat(handlerName, "\" clashes with a class property"));
                }
                _this[handlerName] = curryHandler(fn);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return _this;
    }
    CurryValidator.prototype.extend = function (props) {
        return new CurryValidator(tslib_1.__assign(tslib_1.__assign({}, lodash_1.default.pick(this, ['isValid', 'value', 'path', 'errors'])), props));
    };
    return CurryValidator;
}(Validator));
exports.CurryValidator = CurryValidator;


/***/ }),

/***/ "immer":
/*!************************!*\
  !*** external "immer" ***!
  \************************/
/***/ ((module) => {

module.exports = require("immer");

/***/ }),

/***/ "lodash":
/*!*************************!*\
  !*** external "lodash" ***!
  \*************************/
/***/ ((module) => {

module.exports = require("lodash");

/***/ }),

/***/ "prop-types":
/*!*****************************!*\
  !*** external "prop-types" ***!
  \*****************************/
/***/ ((module) => {

module.exports = require("prop-types");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/***/ ((module) => {

module.exports = require("react");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.tsx");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=react-form.js.map